import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IPsrCustomerService } from "../psr.types"
import { PsrCustomerService } from "./psrCustomerService"
import { safeDayjs } from "@/helpers/dateHelper"
import dayjs from "dayjs"
import { PsrCustomerServiceResponse } from "@/api/backofficeRest/generated/model"

export type IPsrCustomerServiceRaw = PsrCustomerServiceResponse

export const PsrCustomerServiceParser: IParser<
  IPsrCustomerService,
  IPsrCustomerServiceRaw
> = {
  toDomain: (data: IPsrCustomerServiceRaw) => {
    try {
      return new PsrCustomerService(
        data.id,
        dayjs(data.startDate),
        // label/availableNow/alwaysOn are typed optional by the OpenAPI merge but always populated for a stored customer service
        data.label ?? "",
        data.availableNow ?? false,
        data.alwaysOn ?? false,
        safeDayjs(data.endDate),
        data.extraData ?? [],
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
